module.exports = __webpack_public_path__ + "img/CP.e862cca5.png";